<template>
    <div class="switcher-container" @click="$emit('input', !value)">
        <span>{{title}}</span>
        <div class="switcher" :class="{'active': value}"></div>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Boolean,
            required: true,
        },
        title: {
            type: String,
            required: true,
        },
    },
}
</script>

<style lang="scss" scoped>
.switcher-container {
    display: flex;
    background-color: white;
    border: 1 * $rem solid #b4b4b4;
    height: 40 * $rem;
    align-items: center;
    width: 197 * $rem;
    border-radius: 5 * $rem;
    padding-left: 15 * $rem;
    cursor: pointer;
    color: #464646;
    font-size: 15 * $rem;

    .switcher {
        margin-left: auto;
        margin-right: 15 * $rem;
    }
}
</style>
